import { useState } from "react";
import type { SnippetGroup } from "../types";
import { cx } from "./ui";

/**
 * よく使う語をワンクリックで挿す定型フレーズ集。
 * グループをタブで切り替え、押した語を対象欄（プロンプト or スタイル）へ追記する。
 */
export function SnippetChips({
  groups,
  onInsert,
  currentText,
}: {
  groups: SnippetGroup[];
  onInsert: (target: "prompt" | "style", text: string) => void;
  currentText: { prompt: string; style: string };
}) {
  const [active, setActive] = useState(groups[0]?.id ?? "");
  const group = groups.find((g) => g.id === active) ?? groups[0];
  if (!group) return null;

  return (
    <div className="rounded-xl border border-slate-100 bg-slate-50/60 p-2.5">
      <div className="mb-2 flex flex-wrap gap-1">
        {groups.map((g) => (
          <button
            key={g.id}
            type="button"
            onClick={() => setActive(g.id)}
            className={cx(
              "rounded-lg px-2.5 py-1 text-[12px] font-semibold transition",
              g.id === active ? "bg-white text-brand-700 shadow-sm" : "text-slate-400 hover:text-slate-600",
            )}
          >
            {g.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {group.items.map((item) => {
          const used = currentText[group.target].includes(item);
          return (
            <button
              key={item}
              type="button"
              disabled={used}
              onClick={() => onInsert(group.target, item)}
              className={cx("chip", used && "opacity-40")}
              title={used ? "追加済み" : `「${item}」を${group.target === "prompt" ? "プロンプト" : "スタイル"}に追加`}
            >
              {item}
            </button>
          );
        })}
      </div>
    </div>
  );
}
